import { createSlice } from "@reduxjs/toolkit";
import { fetchMapStudentsStatsData } from "../thunks/dashboardThunk"; 

const dashboardSchoolsMapStateInt = createSlice({
  name: "MapSchoolsStatsInt",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

 
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchMapStudentsStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMapStudentsStatsData.fulfilled, (state, action) => {
        state.data = action.payload.data===""?[]:action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMapStudentsStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboardSchoolsMapStateInt.reducer;